import axios from "axios";
import { Button, TextBox, Validator } from "devextreme-react";
import { useState } from "react";
import * as editIcon from "./edit.svg";
import styled from "styled-components";
import { RequiredRule } from "devextreme-react/validator";
import { toastMsg } from "../utils";

const TitleWrapper = styled.header`
  width: 100%;
  height: 64px;
  border-bottom: 1px solid black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h1 {
    margin: 0px;
    font-size: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
  > div:first-child {
    width: 100%;
    .dx-placeholder {
      font-size: 32px;
      font-weight: bold;
    }
    input {
      font-size: 32px;
      font-weight: bold;
    }
    .dx-texteditor.dx-state-active::before,
    .dx-texteditor.dx-state-focused::before,
    .dx-texteditor.dx-editor-filled::after {
      border-bottom: none;
    }
  }
  > div:last-child {
    display: flex;
    .dx-button.dx-button-has-icon:not(.dx-button-has-text):not(.dx-shape-standard) {
      border-radius: 5px;
      margin: 0px 0px 0px 8px;
      min-width: 26px;
      float: left;
      i {
        font-size: 18px;
        font-weight: bold;
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
    .dx-button-has-icon .dx-button-content {
      padding: 0;
    }
    .dx-button-mode-outlined.dx-button-success.dx-button-has-icon {
      i {
        color: black;
      }
    }
  }
`;

const Title = (props) => {
  const { au, id, isAuthor, mode, status, title, titleRef } = props;
  const [isEditMode, setEditMode] = useState(false);
  const [titleValue, setTitleValue] = useState(title);

  const onCancelUpdate = () => {
    setEditMode(false);
  };

  const onClickEdit = () => {
    setEditMode(true);
  };

  const onClickUpdate = (e) => {
    const validationResult = e.validationGroup.validators.reduce((res, ele) => {
      if (ele._$element[0].id === "titleEditor") {
        const { isValid } = ele.validate();
        res = isValid;
      }
      return res;
    }, true);

    const newTitle = titleRef.current.instance.option("value");

    if (validationResult && titleValue !== newTitle) {
      axios
        .put(`${process.env.REACT_APP_BECCO_API_URL}/api/bbs/title/${id}`, {
          title: newTitle,
          au,
        })
        .then(() => {
          setTitleValue(newTitle);
        })
        .then(() => {
          toastMsg(`제목이 변경되었습니다.`, true);
          setEditMode(false);
          e.validationGroup.reset();
        })
        .catch((err) => {
          toastMsg(`에러가 발생했습니다. 관리자에게 문의해주세요.`, false);
          setEditMode(false);
          throw err;
        });
    } else if (titleValue === newTitle) {
      setEditMode(false);
    }
  };

  return (
    <TitleWrapper>
      {!isEditMode && mode !== "create" && (
        <>
          <h1>{titleValue}</h1>
          <div>
            {((isAuthor && status === "1") || mode === "admin") && (
              <Button
                id="editBtn"
                width={26}
                height={26}
                icon={`${editIcon.default}`}
                stylingMode="contained"
                onClick={onClickEdit}
              />
            )}
          </div>
        </>
      )}
      {(isEditMode || mode === "create") && (
        <>
          <div>
            <TextBox
              defaultValue={titleValue}
              id="titleEditor"
              labelMode="hidden"
              maxLength={8000}
              placeholder="제목을 입력하세요"
              ref={titleRef}
              stylingMode="filled"
              width="100%"
            >
              <Validator>
                <RequiredRule message="제목은 필수항목입니다" />
              </Validator>
            </TextBox>
          </div>
          {mode !== "create" && (
            <div>
              <Button
                id="submitBtn"
                width={26}
                height={26}
                icon="check"
                type="success"
                stylingMode="contained"
                onClick={onClickUpdate}
              />
              <Button
                id="cancelBtn"
                width={26}
                height={26}
                icon="close"
                type="success"
                stylingMode="outlined"
                onClick={onCancelUpdate}
              />
            </div>
          )}
        </>
      )}
    </TitleWrapper>
  );
};

export default Title;
